import React, { useEffect, useRef } from "react"
import { motion, AnimatePresence } from "framer-motion"
import CityInput from "./CityInput"

const FormCityField = ({
  terminals = [],
  onClear,
  placeholder,
  handleInputFocus,
  handleInputChange,
  valueInput,
}) => {
  const containerRef = useRef(null)
  const terminalsRef = useRef(null)

  const calculateOffset = () => {
    if (!containerRef.current || !terminalsRef.current) return

    const terminalsWidth = terminalsRef.current.scrollWidth
    const terminalsVisible = terminalsRef.current.offsetWidth

    if (terminalsWidth > terminalsVisible) {
      terminalsRef.current.scrollLeft = terminalsWidth - terminalsVisible
    } else {
      terminalsRef.current.scrollLeft = 0
    }
  }

  useEffect(() => {
    window.addEventListener("resize", calculateOffset)
    return () => window.removeEventListener("resize", calculateOffset)
  }, [])

  useEffect(() => {
    if (terminals.length === 0) {
      if (terminalsRef.current) terminalsRef.current.scrollLeft = 0
      return
    }
    const timeoutId = setTimeout(calculateOffset, 310)
    return () => clearTimeout(timeoutId)
  }, [terminals])

  return (
    <div ref={containerRef} className="flex items-center w-full min-w-0">
      {terminals.length > 0 && (
        <div
          ref={terminalsRef}
          className="flex items-center min-w-0"
          style={{
            overflow: "hidden",
            scrollBehavior: "smooth",
            flexGrow: 0,
            flexShrink: 1,
            flexBasis: "auto",
          }}
        >
          <div className="flex items-center gap-1 whitespace-nowrap">
            <AnimatePresence mode="popLayout" onExitComplete={calculateOffset}>
              {terminals.map((item) => (
                <motion.div
                  key={item.id}
                  layout
                  initial={{ opacity: 0, x: -20, scale: 0.9 }}
                  animate={{ opacity: 1, x: 0, scale: 1 }}
                  exit={{ opacity: 0, x: 20, scale: 0.9 }}
                  transition={{ duration: 0.3, ease: "easeInOut" }}
                >
                  <CityInput value={item.city} onClear={() => onClear(item.id)} />
                </motion.div>
              ))}
            </AnimatePresence>
          </div>
        </div>
      )}

      <input
        type="text"
        className="pl-2 bg-transparent outline-none text-app-content placeholder-app-content-faint"
        style={{
          flexGrow: 1,
          flexShrink: 1,
          flexBasis: "80px",
          minWidth: "80px",
          width: 0,
        }}
        placeholder={placeholder}
        onFocus={handleInputFocus}
        value={valueInput}
        onChange={(e) => handleInputChange(e.target.value)}
      />
    </div>
  )
}

export default FormCityField
